import type { OutcomeToDisplay, Filter } from '../types';
import type { OutcomeParameterName, Market } from '../../../types';
import { createEmptyOutcome } from '../utils/createEmptyOutcome';

/*
 * Фильтрует исходы по значению тотала
 * Создает пустые парные кэфы при их отсутствии (например, когда ТБ 2,5 существует, ТМ 2,5 не существует)
 */
export function filterTotal(
    outcomes: OutcomeToDisplay[],
    filters: Map<OutcomeParameterName, Filter>,
    market: Market,
): OutcomeToDisplay[] {
    let filterTotal: Filter | undefined;
    for (const filter of filters.values()) {
        if (filter.kind === 'NUMERIC_PARAM_VALUE') {
            filterTotal = filter;
            break;
        }
    }

    if (!filterTotal) {
        return [];
    }

    const filteredOutcomes: OutcomeToDisplay[] = [];
    const activeValue = filterTotal.activeValue.value;

    if (activeValue !== undefined) {
        for (const outcome of outcomes) {
            const totalValue = outcome.paramsMap.get(filterTotal.name)?.values().next().value;

            if (totalValue === activeValue) {
                filteredOutcomes.push(outcome);
            }
        }
    }

    // если нет парного кэфа, создаем его на основе параметра рынка противоположного исхода
    if (filteredOutcomes.length === 1) {
        const oppositeOutcomeKind = filteredOutcomes[0].outcome.kind === 'OVER' ? 'UNDER' : 'OVER';
        const oppositeMarketParam = market.params.find((p) => p.outcomeKind === oppositeOutcomeKind);

        if (oppositeMarketParam) {
            filteredOutcomes.push(
                createEmptyOutcome(
                    oppositeMarketParam.ctid,
                    oppositeMarketParam.outcomeKind,
                    oppositeMarketParam.name,
                ),
            );
        }
    }

    // если исходов не нашлось, создаем пустые исходы
    // это фикс для случая, когда исходы на выбранное значение тотала не найдены в выбранном отрезке времени (параметр ROUND)
    if(filteredOutcomes.length === 0) {
        const overMarketParam = market.params.find((p) => p.outcomeKind === 'OVER');
        const underMarketParam = market.params.find((p) => p.outcomeKind === 'UNDER');

        if(overMarketParam) {
            filteredOutcomes.push(createEmptyOutcome(overMarketParam.ctid, overMarketParam.outcomeKind, overMarketParam.name));
        }
        if(underMarketParam) {
            filteredOutcomes.push(createEmptyOutcome(underMarketParam.ctid, underMarketParam.outcomeKind, underMarketParam.name));
        }
    }

    return filteredOutcomes;
}
